import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { AdminUIActionTypes } from "src/common";
import _ from "lodash";

type AllProps = {
  handleAction: ActionHandlerFunction;
  submitAddresses: Function;
}

// Description: Component use to enter individual addresses/domains for Trusted Community
function IndividualFormComponent(props: AllProps) {
  const { handleAction, submitAddresses } = props;
  const [address_field_valid, setAddressFieldValid] = useState<boolean>(false);

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const address_field_valid = !!e.target.value.trim();
    setAddressFieldValid(address_field_valid);
  };

  function submitData(e: React.FormEvent<HTMLFormElement>) {
    e.stopPropagation();
    e.preventDefault();
    const addresses = e.currentTarget.addresses.value;
    // Note: we are removing any duplicate address/domain entered by the user.
    const address_collection: string[] = _.uniq(addresses.split(",").map((address: string) => address.trim().toLowerCase()));
    submitAddresses(address_collection);
  };

  return (
    <Form noValidate onSubmit={submitData}>
      <Form.Group className="mb-2" >
        <Form.Label htmlFor="addresses_ta">Addresses or Domains</Form.Label>
        <Form.Control
          as="textarea" rows={3}
          id="addresses_ta"
          name="addresses" 
          onChange={handleChange} />
      </Form.Group>
      <Form.Text className="text-muted">
        Separate multiple entries with commas, e.g. john@gmail.com, outlook.com
      </Form.Text>
      <div className="btn-panel mt-4">
        <Button type="submit" disabled={!address_field_valid}>Add to List</Button>
        <Button onClick={() => handleAction({ actionType: AdminUIActionTypes.ShowModal })} variant="no-outline-primary">Cancel</Button>
      </div>
    </Form>
  );
}

export default React.memo(IndividualFormComponent);
